module.exports = __webpack_public_path__ + "img/preciousMetals@2x.316aaf5.jpg";